/**
 * Main Layout Component
 * App shell (Playful): rounded left sidebar + top bar + light content canvas.
 */
import React, { ReactNode, useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

interface LayoutProps {
  children: ReactNode;
  title?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, title }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white transition-colors duration-200 dark:bg-secondary-900">
      <Sidebar mobileOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />

      <div className="lg:pl-64">
        <TopBar onMenu={() => setMobileNavOpen(true)} title={title} />
        <main className="mx-auto w-full max-w-[1800px] px-4 py-8 sm:px-6 lg:px-10">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
